<template>
  <v-file-input
    autocomplete="off"
    :label="label"
    :required="required"
    :name="name"
    :accept="getAccept"
    :prepend-inner-icon="iconLeft"
    :append-icon="iconRight"
    :outlined="outlined"
    :loading="loading"
    :rules="getRules"
    :error="getError"
    :error-messages="getErrorContents"
    :value="value"
    :disabled="disabled"
    :readonly="readonly"
    :placeholder="placeholder"
    :hint="info"
    :persistent-hint="info ? true : false"
    validate-on-blur
    @blur="$emit('blur', $event)"
    @change="onChangeFile"
  >
    <template v-slot:prepend v-if="!!$slots.prepend">
      <slot name="prepend" />
    </template>

    <template v-slot:append v-if="!!$slots.append">
      <slot name="append" />
    </template>
  </v-file-input>
</template>

<script>
import EdFormMixin from "./mixins/formControl";

export default {
  name: "EdInputUpload",
  mixins: [EdFormMixin],
  props: {
    extensoes: {
      type: Array,
      required: false,
      default: [],
    },
    isBase: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  data() {
    return {
    };
  },
  beforeDestroy() {},
  created() {},
  mounted() {},
  computed: {

    getAccept(){

      let arrayExtensoes = [];

      let extensoes = {

        "doc" : ["application/msword"],
        "jpg": ["image/jpeg"],
        "text": ["text/plain"],
        "svg": ["image/svg+xml"],
        "xls": ["application/vnd.ms-excel","application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"],
        "pfx": ["application/x-pkcs12"],
        "crt": ["application/pkix-cert"],
      }

      this.extensoes.forEach((value) => {
        if(extensoes[value]){
          arrayExtensoes.push(extensoes[value].join(','))
        }

      })

      return arrayExtensoes.join(',')
    }
  },
  methods: {

    onChangeFile($event) {
      this.$emit('input', $event);
      this.$emit('change', $event)
    },
  },

  watch: {
    accept(){},
    extensoes(){}
  }
};
</script>


// WEBPACK FOOTER //
// src/components/template/EdInputUpload.vue